import { useState, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';

export default function PasswordField({
  value,
  onChange,
  disabled = false,
  ...props
}) {
  const [show, setShow] = useState(false);

  const handleVisibility = useCallback(() => {
    setShow((prev) => !prev);
  }, []);

  return (
    <TextField
      value={value}
      onChange={onChange}
      type={show ? 'text' : 'password'}
      disabled={disabled}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleVisibility} disabled={disabled}>
              {show ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}
